import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Helper function to get redirect path based on user role
const getRedirectPathForRole = (role) => {
  switch (role) {
    case 'custom_role_sk':
      return '/branch-order/create-order';
    case 'custom_role_ck':
      return '/central-kitchen/dashboard';
    case 'custom_role_sales':
      return '/sales/dashboard';
    case 'custom_role_order_receiver':
      return '/order-receiver/dashboard';
    case 'master_admin':
    case 'admin':
      return '/dashboard';
    default:
      return '/dashboard';
  }
};

const RoleBasedRedirect = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user) {
      const path = location.pathname;
      const role = user.role;

      // Sales and order-receiver must not access central kitchen — redirect to their dashboard
      if (path.startsWith('/central-kitchen')) {
        if (role === 'custom_role_sales') {
          navigate('/sales/dashboard', { replace: true });
          return;
        }
        if (role === 'custom_role_order_receiver') {
          navigate('/order-receiver/dashboard', { replace: true });
          return;
        }
      }

      // Redirect role-specific users from main /dashboard to their correct dashboard
      if (path === '/dashboard') {
        const redirectPath = getRedirectPathForRole(role);
        if (['custom_role_sk', 'custom_role_ck', 'custom_role_sales', 'custom_role_order_receiver'].includes(role)) {
          navigate(redirectPath, { replace: true });
        }
      }
    }
  }, [user, loading, location.pathname, navigate]);

  return children;
};

export default RoleBasedRedirect;
